import { AutogrowDirective } from './autogrow.directive';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
@NgModule({
  imports: [CommonModule, AutogrowDirective],
  exports: [AutogrowDirective],
})
export class AutogrowModule {}
